import { isString } from './type-guard';
export const addTrailingSlash = (path) => isString(path) && (path.endsWith('/') || path === '') ? path : path + '/';
//# sourceMappingURL=add-trailing-slash.js.map